import api from "@/helpers/api_helper";
import { apiUrls } from "@/constant/configure";

export const findMyMallPath = async (token: string) => {
    try {
        return await api.post('/mall/spacehome/path', {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(r => {
            return r.data?.mallPath;
        })
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            }
        } else {
            throw e
        }
    }
}

export const checkMallPath = async (mallPath: string, token: string) => {
    try {
        return await api.post('/mall/mall-path/check', {
            mallPath: mallPath,
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(r => {
            console.log('checkMallPath', r);
            return true;
        })
    } catch (e: any) {
        if (e.status === 409) {
            return false;
        }

        if (typeof e === 'string') {
            throw {
                message: e,
            }
        } else {
            throw e
        }
    }
}


export type RequestOpenMallPayload = {
    mallInfo: {
        name: string,
        description?: string,
        mallPath: string,
        snsInfo?: {
            snsName: string,
            url: string,
        }[],
        mallReturnAddressInfo: {
            "postCode": string,
            "recipientAddress": string,
            "recipientAddressDetail": string
        }
    },
    mallBusinessInfo: {
        operatorType: string,
        businessType: string,
        businessItem: string,
        companyName: string,
        ownerName: string,
        managerPhoneNumber: string,
        customerCenterNumber?: string,
        companyAddress: string,
        businessRegistrationNumber: string,
        mailOrderSalesRegistrationNumber: string,
        settleBankCode: string,
        settleBank?: string,
        settleAccountNumber: string,
        settleAccountOwnerName: string,
        settleBankBookUrl: string,
        businessRegistrationCertificateUrl: string,
        mailOrderSalesRegistrationCertificateUrl: string
    },
}
export type RequestOpenMallV2Payload = {
    smsMarketingConsented: boolean;
    emailMarketingConsented: boolean,
}
export const requestOpenMall = async (data: RequestOpenMallPayload, token: string) => {
    try {
        await api.post('/mall', data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            }
        } else {
            throw e
        }
    }
}
export const requestOpenMallV2 = async (data: RequestOpenMallV2Payload) => {
    try {
        await api.post('/mall', data)
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            }
        } else {
            throw e
        }
    }
}

export const checkNicknameDuplicate = async (nickname: string, token: string) => {
    try {
        return await api.get(
            `/nickname/duplicate?nickname=${nickname}`,
            { baseURL: apiUrls.user, headers: { Authorization: `Bearer ${token}` } }
        ).then(r => r)
    } catch (error) { throw error }
}

export const checkEmailDuplicate = async (email: string) => {
    try {
        return await api.get(
            `/email/duplicate?email=${email}`,
            { baseURL: apiUrls.user }
        ).then(r => r)
    } catch (error) { throw error }
}


export type RequestSignUpWithMallPayload = {
    nickname: string;
    imageUrl: string;
    email: string;
    password: string;
    // smsMarketingConsented: boolean;
    // emailMarketingConsented: boolean,
    mallPath: string;
    mallOpenBusinessType: string;
    snsInfo?: [
        {
            snsName: "instagram",
            url: string;
        },
        {
            snsName: "youtube",
            url: string;
        }
    ],
    vendorRecommenderCode?: string;
    businessInfo?: {
        mallReturnAddressInfo: {
            postCode: string;
            recipientAddress: string;
            recipientAddressDetail: string;
        },
        mallBusinessInfo?: {
            operatorType: "SOLE_PROPRIETORSHIP",
            businessType: string;
            businessItem: string;
            companyName: string;
            ownerName: string;
            managerPhoneNumber: string;
            customerCenterNumber: string;
            companyAddress: string;
            businessRegistrationNumber: string;
            mailOrderSalesRegistrationNumber: string;
            settleBankCode: string;
            settleBank: string;
            settleAccountNumber: string;
            settleAccountOwnerName: string;
            settleBankBookUrl: string;
            businessRegistrationCertificateUrl: string;
            mailOrderSalesRegistrationCertificateUrl: string;
        }
    }
}
export const requestSignUpWithMall = async (data: RequestSignUpWithMallPayload, token: string) => {
    try {
        await api.post('/mall/sign-up', data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            }
        } else {
            throw e
        }
    }
}

export const checkOpenState = async (token: string) => {
    try {
        return await api.get('/mall/approval-state', {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(r => {
            return r.data?.runningState || r.data;
        })
    } catch (e: any) {
        console.log('e', e);
        if (e.status === 422 && (e.message === 'No data exists.' || e.data?.message === 'No data exists.')) {
            console.log('test')
            return;
        }

        if (typeof e === 'string') {
            throw {
                message: e,
            }
        } else {
            throw e
        }
    }
}

export const getTemporaryUserInfo = async (token: string) => {
    try {
        const userId = await api.post('/auth/web/user', {}, {
            baseURL: apiUrls.common,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(r => {
            return r.data?.user_id;
        })

        const profile = await api.post('/profile/find', {
            user_id: userId,
        }, {
            baseURL: apiUrls.user,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })

        return profile;

    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            }
        } else {
            throw e
        }
    }
}

export const requestVerifyPhoneCode = async (phoneNumber: string) => {
    try {
        await api.post('/phone/sms/pre-signup/request', {
            phone_number: phoneNumber,
        }, {
            baseURL: apiUrls.user,
        })
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            }
        } else {
            throw e
        }
    }
}

export const confirmVerifyPhoneCode = async (phoneNumber: string, code: string) => {
    try {
        await api.post('/phone/sms/pre-signup/authenticate', {
            phone_number: phoneNumber,
            auth_code: code,
        }, {
            baseURL: apiUrls.user,
        })
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            }
        } else {
            throw e
        }
    }
}